<div class="notification-menu-title-container">
  <span class="material-icons-outlined notification-icon-active">notifications_none</span>
  <span class="title">{{title}}</span>
</div>
